import styled from 'styled-components';

export const TableRow = styled.tr`
  height: 36px;
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey2};
  background: ${({ theme }) => theme.colors.pigeonSubLight};

  & {
    background: ${({ theme, isLastOpenItem }) => isLastOpenItem && theme.colors.veryLightBlue} !important;
  }

  & > td {
    padding: 5px 5px 5px 10px;

    font-size: ${({ theme }) => theme.fontSize.s};
  }

  &:hover td {
    background: ${({ theme }) => theme.colors.pigeonHover};
  }
`;
